export interface DisplayProfile {
  first_name?: string | null;
  last_name?: string | null;
}

export function getProfileDisplayName(profile: DisplayProfile | null | undefined, fallbackEmail?: string | null) {
  const fullName = [profile?.first_name, profile?.last_name].filter(Boolean).join(' ').trim();
  return fullName || fallbackEmail || null;
}

export function getProfileInitials(profile: DisplayProfile | null | undefined, fallbackEmail?: string | null) {
  const firstInitial = profile?.first_name?.trim().charAt(0) ?? '';
  const lastInitial = profile?.last_name?.trim().charAt(0) ?? '';
  const initials = `${firstInitial}${lastInitial}`.toUpperCase();

  if (initials) {
    return initials;
  }

  return fallbackEmail?.slice(0, 2).toUpperCase() || 'U';
}

export function hasProfileDisplayIdentity(profile: DisplayProfile | null | undefined) {
  return Boolean(profile?.first_name || profile?.last_name);
}
